import BancoModel from "../models/bancoModel";
import ClinicaModel from "../models/clinica/clinicaModel";

import { IService } from "./base/iService";

export default class ClinicaService extends IService<ClinicaModel> {
    constructor() {
        super("Clinica");
    }
}